/**
 *    @author:
 *    @since:
 *
 */
import { Util } from 'src/refresh/service/Util';
import { IValidator } from '../../_common/component/IValidator';
import { InternationalAddressComponent} from './international-address.component';
import { Address } from '../../_common/data/input-data';
import { Code } from 'src/refresh/service/constant';
import { ViewportScroller } from '@angular/common';

export class InternationalAddressValidation extends IValidator {

      private viewportScroller:ViewportScroller;

       constructor(private component: InternationalAddressComponent) {
             super();
            this.viewportScroller = this.component.viewportScroller;
       }

       private success: boolean;

       public validate(): boolean {

            this.success = true;
            
            if(Util.isEmpty(this.component.addr.chk_international) || this.component.addr.chk_international!='Y'){
                  return this.success;
            }
            
            //---- [Street Number] ---
            if ( Util.isEmpty(this.component.addr.streetNumber) ) {
                  if ( !this.component.isCustodyOtherThanParent )
                        this.focus(this.component.streetNumberID,'input_intStreetNumberInput_'+this.component.streetNumberID).error_streetNumber = "contact_info_and_mailing_address.streetNumberEmpty"; 
            }
            else if ( Util.hasSpecialCharacter(this.component.addr.streetNumber) ) {
                  this.focus(this.component.streetNumberID,'input_intStreetNumberInput_'+this.component.streetNumberID).error_streetNumber = "contact_info_and_mailing_address.streetNumberInvalid"; 
            }
             
             //---- [Street Name] ---
             if ( Util.isEmpty(this.component.addr.streetName) ) {
                  if ( !this.component.isCustodyOtherThanParent )
                        this.focus(this.component.streetNameID,'input_intStreetNameInput_'+this.component.streetNameID).error_streetName = "contact_info_and_mailing_address.streetNameEmpty"; 
 
             }
             else if ( Util.hasSpecialCharacter(this.component.addr.streetName) ) {
                  this.focus(this.component.streetNameID,'input_intStreetNameInput_'+this.component.streetNameID).error_streetName = "contact_info_and_mailing_address.streetNameInvalid"; 

             }
             
             //---- [Unit] ---
             if ( Util.hasSpecialCharacter(this.component.addr.unit) ) {
                  this.focus(this.component.unitID,'input_intUnitInput_'+this.component.unitID).error_unit = "contact_info_and_mailing_address.unitNumberInvalid"; 
             }
             
             //---- [PO Box] ---
             if ( Util.hasSpecialCharacter(this.component.addr.poBox) ) {
                  this.focus(this.component.poboxID,'input_intPoBoxInput_'+this.component.poboxID).error_poBox = "contact_info_and_mailing_address.poboxIfApplicableInvalid";  
             }
             
             //---- [City/Town] ---
             if ( Util.isEmpty(this.component.addr.base.city) ) {
                  if ( !this.component.isCustodyOtherThanParent )
                        this.focus(this.component.cityID,'input_intCityTownInput_'+this.component.cityID).error_city = "contact_info_and_mailing_address.cityTownEmpty"; 

             }
             else if ( Util.hasSpecialCharacter(this.component.addr.base.city) ) {
                  this.focus(this.component.cityID,'input_intCityTownInput_'+this.component.cityID).error_city = "contact_info_and_mailing_address.cityTownInvalid";  
             }
             
             //---- [Province] ---
          if ( Util.hasSpecialCharacter(this.component.addr.base.province)){
               this.focus(this.component.provinceID,'input_intProvinceInput_'+this.component.provinceID).error_province = "contact_info_and_mailing_address.intProvinceInvalid"; 
          }
             
             //---- [Country] ---
             if ( Util.isEmpty(this.component.addr.base.country )) {
                  if ( !this.component.isCustodyOtherThanParent )
                        this.focus(this.component.countryID,'select_intCountrySelect_'+this.component.countryID).error_country = "contact_info_and_mailing_address.countryEmpty"; 
             }
             
             //---- [Other Country] ---
             if(this.component.addr.base.country == Code.NotFound){             
                   if ( Util.isEmpty(this.component.addr.base.otherCountry) ) {
                        if ( !this.component.isCustodyOtherThanParent )
                              this.focus(this.component.otherCountryID,'input_intOtherCountryInput_'+this.component.otherCountryID).error_otherCountry = "contact_info_and_mailing_address.otherCountryEmpty"; 

                   }
                   else if ( Util.hasSpecialCharacter(this.component.addr.base.otherCountry) ) {
                        this.focus(this.component.otherCountryID,'input_intOtherCountryInput_'+this.component.otherCountryID).error_otherCountry = "contact_info_and_mailing_address.otherCountryInvalid"; 
                   }
             }
             
             //---- [Postal Code] ---
             if ( Util.isEmpty(this.component.addr.postalCode) ) {
                  if ( !this.component.isCustodyOtherThanParent ) {
                        this.focus('int_'+this.component.countryID,'input_intPostalZIPCountryCodeInput_'+this.component.countryID).error_postal = "contact_info_and_mailing_address.intPostalZIPCountryCodeEmpty"; 
                  }
             }
             else if ( Util.hasSpecialCharacter(this.component.addr.postalCode) ) {
                  this.focus('int_'+this.component.countryID,'input_intPostalZIPCountryCodeInput_'+this.component.countryID).error_postal = "contact_info_and_mailing_address.intPostalZIPCountryCodeInvalid"; 
             }

            return this.success;

       }
       
       private jump(tagId:string) : InternationalAddressComponent {
               if ( this.success )
                    this.viewportScroller.scrollToAnchor(tagId);
               this.success = false;
               return this.component;
       }

       private focus(tagId:string,ctrlId:string) : InternationalAddressComponent {
            if ( this.success ) {
                 this.viewportScroller.scrollToAnchor(tagId);
                 let ctrl = document.getElementById(ctrlId);
                 //console.log(ctrl);
                 if ( ctrl ) ctrl.focus();
            }
                 
            this.success = false;
            return this.component;
      }
}

